import { useFancyClothesDesign } from "../shared/hooks/useFancyClothesDesign";
import { css } from "@emotion/react";
import { styleUtils, theme } from "@minted/minted-components";
import Color from "color";
import React, { memo, useMemo } from "react";

type MapButtonProps = {
  onClick: () => void;
  text: string;
};

const MapButton = ({ onClick, text }: MapButtonProps) => {
  const { button, designProvider } = useFancyClothesDesign();
  const {
    buttonColor,
    cornerStyle,
    fontFamily,
    fontSizeFactor,
    lineHeightFactor,
  } = button;
  const { backgroundColor } = designProvider;

  const buttonStyles = useMemo(() => {
    let borderRadius = "0";
    if (cornerStyle === "rounded") {
      borderRadius = styleUtils.rem(5);
    } else if (cornerStyle === "round") {
      borderRadius = styleUtils.rem(50);
    }

    const textColor = backgroundColor;
    const bgColor = buttonColor;

    const activeColor = Color(bgColor).darken(0.1).rgb().string();
    const activeTextColor = Color(textColor).lighten(0.08).rgb().string();

    return css`
      background-color: ${bgColor};
      background-image: none;
      border-color: transparent;
      border-radius: ${borderRadius};
      border-style: solid;
      border-width: ${styleUtils.rem(1)};
      color: ${textColor};
      cursor: pointer;
      display: inline-block;
      font-family: ${fontFamily};
      font-size: ${styleUtils.rem(14 * fontSizeFactor)};
      line-height: ${lineHeightFactor};
      padding-bottom: ${styleUtils.rem(6)};
      padding-left: ${theme.spacing.x3};
      padding-right: ${theme.spacing.x3};
      padding-top: ${styleUtils.rem(6)};
      text-decoration: none;
      touch-action: manipulation;
      vertical-align: middle;
      white-space: nowrap;

      &:hover,
      &:focus,
      &:active {
        background-color: ${activeColor};
        color: ${activeTextColor};
      }
    `;
  }, [
    backgroundColor,
    buttonColor,
    cornerStyle,
    fontFamily,
    fontSizeFactor,
    lineHeightFactor,
  ]);

  return (
    <button css={buttonStyles} onClick={onClick} type="button">
      {text}
    </button>
  );
};

const MemoizedMapButton = memo(MapButton);

export { MemoizedMapButton as MapButton };

export default MemoizedMapButton;
